export default {
    translation: {
        name: 'Name',
    }
};
